// NavigationModeIndicator.tsx
import React from 'react';

interface NavigationModeIndicatorProps {
  isActive: boolean;
}

const NavigationModeIndicator: React.FC<NavigationModeIndicatorProps> = ({ isActive }) => {
  if (!isActive) return null;

  return (
    <div className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-50 animate-fadeIn">
      <div className="bg-grey-darker dark:bg-grey-darker text-white px-6 py-3 rounded-lg shadow-lg">
        <p className="text-sm font-medium">
          Press a key: <span className="ml-2">
            <kbd className="px-2 py-1 bg-grey-darker rounded text-xs">H</kbd> Home
            <kbd className="px-2 py-1 bg-grey-darker rounded text-xs ml-2">S</kbd> Study
            <kbd className="px-2 py-1 bg-grey-darker rounded text-xs ml-2">R</kbd> Review
            <kbd className="px-2 py-1 bg-grey-darker rounded text-xs ml-2">A</kbd> Analytics
            <kbd className="px-2 py-1 bg-grey-darker rounded text-xs ml-2">B</kbd> Bookmarks
          </span>
        </p>
      </div>
    </div>
  );
};

export default NavigationModeIndicator;